import "./Modal.css";

export const Modal = ({
  children,
  isOpen,
  closeModal,
  bkgColorModalCointainer,
}) => {

  const stopPropagation = (e) => {
    e.stopPropagation();
  }


  return (
    <article className={`modal ${isOpen && "is-open"}`} onClick={stopPropagation}>
      <div
        className={`modal-container ${
          bkgColorModalCointainer
            ? "modal-container-white"
            : "modal-container-purple"
        }`}
      >
        <button
          className={`modal-close ${
            !bkgColorModalCointainer ? "modal-close-purple" : ""
          }`}
          onClick={closeModal}
        >
          X
        </button>

        {children}
      </div>
    </article>
  );
};
